var render = function render(){var _vm=this,_c=_vm._self._c;return _c('img',{attrs:{"id":"avatar","width":"45","height":"45","alt":"user_name"}})
}
var staticRenderFns = []

export { render, staticRenderFns }